module.exports = __webpack_public_path__ + "static/img/moose_pictgrid5_800x741.a502b6d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/moose_pictgrid5_800x741.jpg
// module id = INnD
// module chunks = 0